import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const RedoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M15.3333 16.3333L22 9.66667L15.3333 3"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 9.66666H7.33333C5.91885 9.66666 4.56229 10.2286 3.5621 11.2288C2.5619 12.2289 2 13.5855 2 15C2 16.4145 2.5619 17.771 3.5621 18.7712C4.56229 19.7714 5.91885 20.3333 7.33333 20.3333H8.66667"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

RedoIcon.displayName = 'RedoIcon';
